import { Injectable } from '@angular/core';
import { Branch, FinancialInstitutionLender } from '@models/lender';
import { LawFirm } from '@models/lawFirms';
import { LawFirmEmployee } from '@models/lawFirms';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './global-data-management.request.actions';

@Injectable({
	providedIn: 'root',
})
export class GlobalDataManagementRequestDispatch {
	@Dispatch()
	RequestFinancialInstitutionChange = (
		institution: FinancialInstitutionLender,
	): actions.RequestFinancialInstitutionChange =>
		new actions.RequestFinancialInstitutionChange(institution);

	@Dispatch()
	RequestBranchChange = (institutionId: string, branch: Branch) =>
		new actions.RequestBranchChange({ institutionId, branch });

	@Dispatch()
	RequestLawFirmChange = (lawfirm: LawFirm) =>
		new actions.RequestLawFirmChange(lawfirm);

	@Dispatch()
	RequestLawFirmEmployeeChange = (
		lawfirmId: string,
		lawfirmEmployee: LawFirmEmployee,
	) => new actions.RequestLawFirmEmployeeChange({ lawfirmId, lawfirmEmployee });
}
